import React from 'react';
import _ from 'lodash';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { getFormListAction } from '../../services/request';
import { FormPanel } from './FormPanel';

import { useFullScreen } from '../../services/hooks';

export const FormListPanel = () => {
  const { loading, payload, error } = useQuery(getFormListAction());
  const [forms, setForms] = React.useState([]);
  const [selectedForm, setSelectedForm] = React.useState('');
  const margin = useFullScreen() ? '0%' : '0%';

  React.useEffect(() => {
    if (!error && !loading) {
      setForms(payload.results);
    }
  }, [loading]);

  const handleChangeForm = val => {
    setTimeout(() => {
      setSelectedForm(val);
    }, 300);
    setSelectedForm('');
  };

  return (
    <Box display="flex" flexDirection="column" style={{ marginLeft: margin, marginRight: margin }}>
      <FormControl>
        <InputLabel>Formularze</InputLabel>
        <Select
          value={selectedForm}
          label="forms"
          onChange={e => handleChangeForm(e.target.value)}
        >
          {!_.isEmpty(forms)
            ? _.map(forms, (obj, idx) => (
              <MenuItem value={obj} key={idx}>
                {obj.identifier} - wersja {obj.version}
              </MenuItem>
            ))
            : []}
        </Select>
      </FormControl>
      { _.isObject(selectedForm)
        ? <FormPanel form={selectedForm} />
        : null}
    </Box>
  );
};
